<div id="main_view">
  <div class="em-hidden-print">
    <op-header>
      <op-header-item hiddenSmall="true">
        <op-appcues-launchpad position="bottom-left"></op-appcues-launchpad>
      </op-header-item>
      <op-header-item hiddenSmall="true">
        <op-apps-toggle [apps]="currentUser.openairApps"></op-apps-toggle>
      </op-header-item>
      <op-header-item hiddenSmall="true">
        <op-airline-selector [airlines]="airlines" [current]="currentAirline"
          (onChange)="airlineChange($event)"></op-airline-selector>
      </op-header-item>
      <op-header-item>
        <op-user-actions [user]="currentUser" (onLogout)="logout()"></op-user-actions>
      </op-header-item>
    </op-header>
  </div>
  <div emSidebarTarget isPrimary="true" id="page-content" cdkScrollable class="em-print-area">
    <div id="page-content-inner" ui-view></div>
  </div>
  <div class="em-hidden-print">
    <op-primary-sidebar
      [menuOptions]="menuOptions"
      [languages]="languages"
      [currentLanguage]="currentLanguage"
      (onLanguageChange)="languageChange($event)">
    </op-primary-sidebar>
  </div>
  <div id="ng2-root-session-timeout-modal" class="em-hidden-print" uk-modal>
    <div class="uk-modal-dialog uk-modal-body">
      <p>
        <i class="md-48 uk-text-warning uk-margin-small-right" em-icon="warning"></i>
        <span>Your session is about to expire due to inactivity. To keep working, select Continue.</span>
      </p>
      <div class="uk-modal-footer uk-text-right">
        <button type="button" class="uk-button uk-button-primary uk-modal-close">Continue</button>
      </div>
    </div>
  </div>
</div>
